module.exports = __webpack_public_path__ + "static/s4ten-logo-844c13c7bcd7ea2b02e24bb265e24b73.png";